export const isFormErrorHtml = responseText => responseText && responseText.length ? responseText[0] === '<' : false;